import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, tap } from "rxjs";
import { AppRoute } from "./app-routing.module";

import { AuthenticationActions } from "./shared/authentication/action-types";
import { UserAction } from "./shared/user/action-types";

@Injectable()
export class AppEffects {

    readonly onSingInEvent$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AuthenticationActions.signIn),
            tap(() => this.router.navigate([AppRoute.loginPopup]))

        ),
        { dispatch: false }
    )

    readonly onSingedInEvent$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AuthenticationActions.signedIn),
            map(() => UserAction.loadUser())
        )
    )

    readonly onSingedOutEvent$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AuthenticationActions.signedOut),
            map(() => UserAction.offloadUser())
        )
    )

    constructor(
        private readonly actions$: Actions,
        private readonly router: Router
    ) { }
}